module.exports = __webpack_public_path__ + "volum_circle5.png?a0d70c5c636fd56f001606b53b1b3877";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volum_circle5.png
// module id = 712
// module chunks = 0